<template>
  <div class="discovery-section">
    <div>
      <div class="position-relative z-0">
        <div
          style="
            position: relative;
            top: 0px;
            left: 0;
            z-index: 2;
            display: flex;
          "
        >
          <v-btn
            v-if="
              getUserProfile.level.find(
                ({ id }) =>
                  id == appLevel.adminAudit || id == appLevel.administrator
              ) !== undefined
            "
            color="blue darken-1"
            type="button"
            small
            outlined
            class="white--text"
            style="position: relative; top: 0px; z-index: 2; margin-right: 20px"
            @click="addDiscovery"
          >
            + Tambah
          </v-btn>
          <div
            v-if="detailData.audit_type.id == 2"
            style="width: 210px; height: 45px"
          >
            <v-autocomplete
              v-model="paramAPI.area"
              :items="dropdown.area"
              @change="areaWatcher"
              label="Area"
              item-text="name"
              item-value="id"
              return-id
              dense
              outlined
              clearable
            ></v-autocomplete>
          </div>
          <div
            v-if="detailData.audit_type.id == 1"
            style="width: 210px; height: 45px"
          >
            <v-autocomplete
              v-model="paramAPI.scope"
              :items="dropdown.scope"
              @change="scopeWatcher"
              label="Scope"
              item-text="name"
              item-value="id"
              return-id
              dense
              outlined
              clearable
            ></v-autocomplete>
          </div>
        </div>
      </div>
      <v-data-table
        fixed-header
        mobile-breakpoint="0"
        height="50vh"
        item-key="id"
        style="cursor: pointer"
        elevation="1"
        :headers="discoveryHeaders"
        :items="discoveryData"
        :loading="loading"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
        }"
        @click:row="discoveryRowClick"
      >
        <template v-slot:[`item.description`]="{ item }">
          <div style="width: 210px; font-size: 12px">
            {{ item.description }}
          </div>
        </template>
        <template v-slot:[`item.objective_evidence`]="{ item }">
          <div
            @click.stop="
              openEvidenceDialog(
                item.id,
                item.objective_evidence,
                'Objective',
                item
              )
            "
            style="
              width: 90px;
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            <v-btn
              v-if="
                item.objective_evidence != null &&
                item.objective_evidence.length > 0
              "
              x-small
              text
              outlined
              color="primary"
            >
              <v-icon x-small>mdi-magnify</v-icon>
              Lihat
            </v-btn>
            <v-btn v-else x-small text outlined color="green">
              <v-icon x-small>mdi-upload</v-icon>Upload
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.corrective_evidence`]="{ item }">
          <div
            @click.stop="
              openEvidenceDialog(
                item.id,
                item.corrective_evidence,
                'Corrective',
                item
              )
            "
            style="
              width: 90px;
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            <v-btn
              v-if="item.discovery != null && item.discovery.length > 0"
              x-small
              text
              outlined
              color="primary"
            >
              <v-icon x-small>mdi-magnify</v-icon>
              Lihat
            </v-btn>
            <v-btn v-else x-small text outlined color="green">
              <v-icon x-small>mdi-upload</v-icon>Upload
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.corrective_due_date`]="{ item }">
          <div
            @click.stop
            style="
              width: 110px;
              height: 40px;
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            <v-text-field
              style="font-size: 12px"
              v-model="item.corrective_due_date"
              type="date"
              name="date"
              step="1"
              dense
              @change="updateCorrectiveDueDate(item)"
              :readonly="
                getUserProfile.level.find(
                  ({ id }) => id == appLevel.adminAudit
                ) !== undefined
              "
            />
          </div>
        </template>
        <template v-slot:[`item.corrective_plan_due_date`]="{ item }">
          <div
            @click.stop
            style="
              width: 110px;
              height: 40px;
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            <v-text-field
              @change="updateCorrectivePlanDueDate(item)"
              style="font-size: 12px"
              v-model="item.corrective_plan_due_date"
              type="date"
              name="date"
              step="1"
              dense
              :readonly="
                getUserProfile.level.find(
                  ({ id }) => id == appLevel.adminAudit
                ) !== undefined
              "
            />
          </div>
        </template>
        <template v-slot:[`item.corrective_plan_desc`]="{ item }">
          <div
            style="
              width: 50px;
              padding: 0;
              display: flex;
              flex-direction: row;
              justify-content: center;
            "
          >
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ attrs, on }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="openCorrectivePlanDialog(item)"
                >
                  <v-icon small color="info">mdi-comment-alert</v-icon>
                </div>
              </template>
              <span>Klik untuk melihat catatan</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.scope`]="{ item }">
          <div
            style="
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            {{ item.scope != null ? item.scope.name : '-' }}
          </div>
        </template>
        <template v-slot:[`item.area`]="{ item }">
          <div
            style="
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            {{ item.area != null ? item.area.name : '-' }}
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div
            v-if="
              getUserProfile.level.find(
                ({ id }) =>
                  id == appLevel.adminAudit || id == appLevel.administrator
              ) !== undefined
            "
            style="
              font-size: 12px;
              padding: 0;
              display: flex;
              flex-direction: row;
            "
          >
            <v-btn icon x-small @click.stop="deleteItem(item)">
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
    <div>
      <!-- Dialog Form Discovery -->
      <v-dialog v-model="discoveryFormDialog" width="500" persistent>
        <v-form
          v-if="form != null"
          :disabled="loading"
          lazy-validation
          ref="entryFormDiscovery"
          @submit.prevent="saveFormDiscovery"
          style="position: relative"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Bukti Temuan Audit
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-row class="pb-10">
                <!-- <v-col cols="12" style="padding: 0; margin-top: 20px">
                    <v-row no-gutters style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                        <p
                            style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                            "
                        >
                            Bukti Temuan
                        </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                        </v-col>
                    </v-row>
                    </v-col> -->
                <v-col cols="12" style="padding: 0; margin-top: 20px">
                  <v-row no-gutters style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Keterangan
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-textarea
                        v-model="form.description"
                        :rules="rules.descRules"
                        :auto-grow="true"
                        rows="3"
                        outlined
                        clear-icon="mdi-close-circle"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  v-if="detailData.audit_type.id == 2"
                  cols="12"
                  style="padding: 0"
                >
                  <v-row no-gutters style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Area
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="height: 45px">
                        <v-autocomplete
                          v-model="form.area_id"
                          :items="dropdown.area"
                          :rules="rules.areaRules"
                          item-text="name"
                          item-value="id"
                          return-id
                          outlined
                          clearable
                          dense
                        >
                        </v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  v-if="detailData.audit_type.id == 1"
                  cols="12"
                  style="padding: 0"
                >
                  <v-row no-gutters style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Scope
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="height: 45px">
                        <v-autocomplete
                          v-model="form.scope_id"
                          :items="dropdown.scope"
                          :rules="rules.scopeRules"
                          item-text="name"
                          item-value="id"
                          return-id
                          outlined
                          clearable
                          dense
                        >
                        </v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                @click="closeFormDiscovery"
                color="error"
                text
                outlined
                type="button"
                :loading="loading"
              >
                Batal
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                text
                outlined
                type="submit"
                :loading="loading"
              >
                simpan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- Dialog Evidence -->
      <v-dialog
        v-if="discoveryData !== null"
        v-model="evidenceDialog"
        width="500"
        persistent
      >
        <v-card style="position: relative">
          <v-card-title class="text-h5 grey lighten-2">
            {{ evidenceTitleModal }} Evidence File
          </v-card-title>
          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <v-data-table
                v-if="evidenceFile != null"
                mobile-breakpoint="0"
                fixed-header
                height="300"
                style="cursor: pointer"
                :headers="evidenceHeaders"
                :items="evidenceFile"
                @click:row="readyToDownload"
              >
                <template v-slot:[`item.subject`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{
                      item.subject !== null
                        ? item.subject !== ''
                          ? item.subject
                          : '-'
                        : '-'
                    }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    <v-btn
                      v-if="
                        getUserProfile.level.find(
                          ({ id }) => id == appLevel.picAudit
                        ) !== undefined && evidenceTitleModal == 'Corrective'
                      "
                      icon
                      x-small
                      @click.stop="
                        unlinkDokumen(
                          item.file.slice(item.file.lastIndexOf('/') + 1)
                        )
                      "
                      style="margin-right: 5px"
                    >
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="
                        getUserProfile.level.find(
                          ({ id }) =>
                            id == appLevel.adminAudit ||
                            id == appLevel.administrator
                        ) !== undefined && evidenceTitleModal == 'Objective'
                      "
                      icon
                      x-small
                      @click.stop="
                        unlinkDokumen(
                          item.file.slice(item.file.lastIndexOf('/') + 1)
                        )
                      "
                      style="margin-right: 5px"
                    >
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                    <v-btn icon x-small @click.stop="readyToDownload(item)">
                      <v-icon color="green">mdi-download</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>

              <v-btn
                v-if="
                  getUserProfile.level.find(
                    ({ id }) =>
                      id == appLevel.adminAudit || id == appLevel.administrator
                  ) !== undefined && evidenceTitleModal == 'Objective'
                "
                elevation="0"
                style="margin-right: auto; width: 100%"
                :loading="loading"
                color="primary"
                @click="openUploadModal('upload')"
              >
                <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
                <span :style="`font-weight: bold; color:white;`"
                  >Tambah File</span
                >
              </v-btn>
              <v-btn
                v-if="
                  getUserProfile.level.find(
                    ({ id }) => id == appLevel.picAudit
                  ) !== undefined && evidenceTitleModal == 'Corrective'
                "
                elevation="0"
                style="margin-right: auto; width: 100%"
                :loading="loading"
                color="primary"
                @click="openUploadModal('upload')"
              >
                <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
                <span :style="`font-weight: bold; color:white;`"
                  >Tambah File</span
                >
              </v-btn>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              @click="closeEvidenceDialog"
              :loading="loading"
            >
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="
                getUserProfile.level.find(
                  ({ id }) => id == appLevel.picAudit
                ) !== undefined && evidenceTitleModal == 'Corrective'
              "
              color="error"
              text
              outlined
              :loading="loading"
              @click="deleteAllFile"
            >
              Delete all File
            </v-btn>
            <v-btn
              v-if="
                getUserProfile.level.find(
                  ({ id }) =>
                    id == appLevel.adminAudit || id == appLevel.administrator
                ) !== undefined && evidenceTitleModal == 'Objective'
              "
              color="error"
              text
              outlined
              :loading="loading"
              @click="deleteAllFile"
            >
              Delete all File
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog Upload -->
      <v-dialog v-model="uploadDialog" width="500" persistent>
        <v-form
          :disabled="loading"
          lazy-validation
          ref="entryFormUpload2"
          @submit.prevent="submitUploadDoc"
          style="position: relative"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> UPLOAD </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Subject
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div>
                      <v-text-field
                        outlined
                        v-model="file_subject"
                        dense
                        :rules="rules.subjectRules"
                      ></v-text-field>
                    </div>
                    <div
                      style="
                        padding: 10px;
                        border: 2px dashed grey;
                        height: 70px;
                      "
                    >
                      <v-file-input
                        placeholder="Pilih File"
                        dense
                        append-icon="mdi-paperclip"
                        prepend-icon=""
                        @change="uploadFile"
                        :rules="rules.docRules"
                      ></v-file-input>
                    </div>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                id="closeFileUpload2"
                color="error"
                text
                outlined
                type="reset"
                @click="openUploadModal('close')"
                :loading="loading"
              >
                close
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                text
                outlined
                type="submit"
                :loading="loading"
                :disabled="fileName === '' || file_subject === ''"
              >
                simpan file
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- Dialog Corrective Plan -->

      <v-dialog
        v-if="correctivePlanDesc != null"
        v-model="correctivePlanDialog"
        width="500"
        persistent
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Rencana Perbaikan
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    v-model="correctivePlanDesc.corrective_plan_desc"
                    :auto-grow="true"
                    rows="3"
                    outlined
                    clear-icon="mdi-close-circle"
                    :readonly="
                      getUserProfile.level.find(
                        ({ id }) => id == appLevel.picAudit
                      ) !== undefined
                    "
                  ></v-textarea>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-btn
            style="position: absolute; top: 10px; right: 10px"
            fab
            icon
            x-small
            outlined
            @click="closeCorrectivePlanDialog"
          >
            <v-icon size="30" color="red">mdi-close</v-icon>
          </v-btn>
          <v-card-actions>
            <v-btn
              v-if="
                getUserProfile.level.find(
                  ({ id }) =>
                    id == appLevel.adminAudit || id == appLevel.administrator
                ) !== undefined
              "
              color="primary"
              text
              outlined
              @click="updateCorrectivePlanDesc"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
// import { mapGetters } from 'vuex'
import buildType from '../../../../services/buildType'
export default {
  name: 'DiscoverySection',
  props: [
    'getUserProfile',
    'appLevel',
    'dropdown',
    'detailData',
    'discoveryData',
    'evidenceHeaders'
  ],
  data() {
    return {
      dssApi: buildType.apiURL('dss'),
      uploadApi: buildType.apiURL('upload2'),
      form: null,
      //   discoveryData: [],
      paramAPI: {
        keyword: '',
        offset: 0,
        limit: 10,
        area: null,
        scope: null
      },
      rules: {
        docRules: [],
        subjectRules: [],
        descRules: [],
        areaRules: [],
        scopeRules: []
      },
      discoveryFormDialog: false,
      evidenceDialog: false,
      evidenceFile: null,
      evidenceTitleModal: '',
      fileName: '',
      uploadDialog: false,
      file_subject: null,
      auditItemId: null,
      loading: false,
      correctivePlanDialog: false,
      correctivePlanDesc: null
    }
  },

  computed: {
    // ...mapGetters(['getUserProfile']),
    discoveryHeaders() {
      const arrdiscoveryHeaders = [
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        },
        {
          text: 'Temuan',
          value: 'objective_evidence',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'left',
          sortable: false
        }
      ]
      if (this.detailData.audit_type.id == 1) {
        arrdiscoveryHeaders.push({
          text: 'Scope',
          value: 'scope',
          align: 'left',
          sortable: false
        })
      }
      if (this.detailData.audit_type.id == 2) {
        arrdiscoveryHeaders.push({
          text: 'Area',
          value: 'area',
          align: 'left',
          sortable: false
        })
      }
      arrdiscoveryHeaders.push(
        {
          text: 'Rencana Perbaikan',
          value: 'corrective_plan_desc',
          align: 'left',
          sortable: false
        },
        {
          text: 'Due Date Rencana Perbaikan',
          value: 'corrective_plan_due_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Due Date Perbaikan',
          value: 'corrective_due_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Bukti Perbaikan',
          value: 'corrective_evidence',
          align: 'left',
          sortable: false
        }
      )

      return arrdiscoveryHeaders
    }
  },
  methods: {
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },

    areaWatcher() {
      setTimeout(() => {
        this.$emit('getDiscoveryItems', this.paramAPI)
      }, 200)
    },
    scopeWatcher() {
      setTimeout(() => {
        this.$emit('getDiscoveryItems', this.paramAPI)
      }, 200)
    },
    closeFormDiscovery() {
      this.discoveryFormDialog = false
      this.$refs.entryFormDiscovery.reset()
      setTimeout(() => {
        this.form = null
      }, 300)
    },
    discoveryRowClick(item) {
      console.log(item)
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.adminAudit || id == this.appLevel.administrator
        ) !== undefined
      ) {
        this.form = {
          act: 'update',
          id: item.id,
          description: item.description
        }

        if (this.detailData.audit_type.id == 1) {
          this.form.scope_id = item.scope.id
        }

        if (this.detailData.audit_type.id == 2) {
          this.form.area_id = item.area.id
        }
        setTimeout(() => {
          this.discoveryFormDialog = true
        }, 100)
      }
    },
    addDiscovery() {
      this.form = {
        act: 'add',
        audit_id: this.detailData.id,
        description: null
      }

      if (this.detailData.audit_type.id == 1) {
        this.form.scope_id = null
      }

      if (this.detailData.audit_type.id == 2) {
        this.form.area_id = null
      }
      setTimeout(() => {
        this.discoveryFormDialog = true
      }, 100)
    },
    saveFormDiscovery() {
      this.rules.descRules = [(v) => !!v || 'Description is required']
      if (this.detailData.audit_type.id == 2) {
        this.rules.areaRules = [(v) => !!v || 'Area is required']
      }
      if (this.detailData.audit_type.id == 1) {
        this.rules.scopeRules = [(v) => !!v || 'Scope is required']
      }

      if (!this.$refs.entryFormDiscovery.validate()) return

      const form = {
        act: this.form.act,
        description: this.form.description
      }

      if (this.detailData.audit_type.id == 1 && this.form.scope_id != null) {
        form.scope_id = this.form.scope_id
      }
      if (this.detailData.audit_type.id == 2 && this.form.area_id != null) {
        form.area_id = this.form.area_id
      }
      if (this.form.act == 'add') {
        form.audit_id = this.form.audit_id
      }
      if (this.form.act == 'update') {
        form.id = this.form.id
      }

      console.log('form>>>', form)
      this.submitFormDiscovery(form)
    },
    async submitFormDiscovery(form) {
      await axios
        .post(`${this.dssApi}audit/discoveryitem/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.$emit('getDiscoveryItems')
            this.closeFormDiscovery()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },

    openEvidenceDialog(id, obj, title) {
      setTimeout(() => {
        this.auditItemId = id
        this.evidenceTitleModal = title
        this.evidenceFile = obj
      }, 10)
      setTimeout(() => {
        this.evidenceDialog = true
      }, 300)
    },
    closeEvidenceDialog() {
      this.evidenceDialog = false
      setTimeout(() => {
        this.evidenceTitleModal = ''
        this.evidenceFile = null
        this.auditItemId = null
      }, 300)
    },
    unlinkDokumen(fName, pValue) {
      console.log('Unlink>>>', fName)

      this.loading = true
      const data = {
        module: 'audit',
        file_name: fName
      }
      axios
        .post(`${this.uploadApi}esanqua/dss/unlink`, data)
        .then((res) => {
          console.log('Unlink>>>>>', res)

          if (res.data.status_code === '00') {
            this.fileName = ''
            if (pValue === undefined) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue === undefined) {
              if (res.data.status_msg === 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      console.log('removeFileFromDetail>>', fName, this.evidenceFile)

      for (let i = 0; i < this.evidenceFile.length; i++) {
        if (this.evidenceFile[i].file.includes(fName)) {
          this.evidenceFile.splice(i, 1)
        }
      }
      console.log('this.evidenceFil after>>', this.evidenceFil)
      this.updatePhoto(false)
    },
    async updatePhoto(isAddFile) {
      // this.loading = true
      console.log('upload form>>>', this.evidenceFile)
      const file = []
      if (this.evidenceFile != null) {
        for (let i = 0; i < this.evidenceFile.length; i++) {
          const fName = this.evidenceFile[i].file.slice(
            this.evidenceFile[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.evidenceFile[i].subject,
            file: fName
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileName
        })
      }
      const form = {
        id: this.auditItemId
      }
      if (this.evidenceTitleModal == 'Objective') {
        Object.assign(form, {
          objective_evidence: file
        })
      }
      if (this.evidenceTitleModal == 'Corrective') {
        Object.assign(form, {
          corrective_evidence: file
        })
      }
      console.log('upload form>>>', form)
      await axios
        .post(`${this.dssApi}audit/discoveryitem/update_file_upload`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileName = ''
            if (document.getElementById('closeFileUpload2') != null) {
              document.getElementById('closeFileUpload2').click()
            }
            this.evidenceFile = []
            setTimeout(() => {
              for (let i = 0; i < file.length; i++) {
                this.evidenceFile.push({
                  subject: file[i].subject,
                  file: 'http://10.10.20.8:8020/dss/audit/' + file[i].file
                })
              }
              console.log('this.evidenceFile>>>>', this.evidenceFile)

              this.$emit('getDiscoveryItems')
            }, 300)
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileName)
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
          this.fileName = ''
          // this.$refs.entryFormUpload.reset()
        })
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          // this.loading = true
          const arrFileName = []
          for (let i = 0; i < this.evidenceFile.length; i++) {
            const fileName = this.evidenceFile[i].file.slice(
              this.evidenceFile[i].file.lastIndexOf('/') + 1
            )
            const data = {
              module: 'audit',
              file_name: fileName
            }
            await axios
              .post(`${this.uploadApi}esanqua/dss/unlink`, data)
              .then((res) => {
                console.log(`Unlink-${i + 1}>>>`, res)

                if (res.data.status_code === '00') {
                  arrFileName.push(fileName)
                }
                return null
              })
              .catch((err) => {
                console.log(`Err Unlink-${i + 1}>>>`, err)
                return null
              })
          }
          console.log('deleteAll>>>>>', arrFileName)

          const form = {
            id: this.auditItemId
          }
          if (this.evidenceTitleModal == 'Objective') {
            Object.assign(form, {
              objective_evidence: []
            })
          }
          if (this.evidenceTitleModal == 'Corrective') {
            Object.assign(form, {
              corrective_evidence: []
            })
          }
          await axios
            .post(`${this.dssApi}audit/item/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)

                this.$emit('getDiscoveryItems')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.closeEvidenceDialog()
              }, 100)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    uploadFile(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'audit')
          axios
            .post(`${this.uploadApi}esanqua/dss`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileName = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileName = ''
          }, 300)
        }
      } else {
        this.fileName = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    openUploadModal(event) {
      if (event === 'upload') {
        setTimeout(() => {
          this.uploadDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileName !== '') {
          let fName = ''
          fName = this.fileName
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload2.reset()
        setTimeout(() => {
          this.uploadDialog = false
        }, 500)
      }
      this.fileName = ''
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload2.validate()) {
          self.updatePhoto(true)
        }
      })
    },

    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(`${this.dssApi}audit/discoveryitem/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.$emit('getDiscoveryItems')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },

    openCorrectivePlanDialog(obj) {
      console.log(obj)
      this.correctivePlanDesc = obj
      setTimeout(() => {
        this.correctivePlanDialog = true
      }, 100)
    },
    closeCorrectivePlanDialog() {
      this.correctivePlanDialog = false
      setTimeout(() => {
        this.correctivePlanDesc = null
      }, 100)
    },

    async updateCorrectivePlanDesc() {
      const xForm = {
        act: 'update',
        id: this.correctivePlanDesc.id,
        corrective_plan_desc: this.correctivePlanDesc.corrective_plan_desc
      }
      console.log('updateCorrectivePlanDesc>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/discoveryitem/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.$emit('getDiscoveryItems')
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }

          this.correctivePlanDialog = false
          this.correctivePlanDesc = null
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )

          this.correctivePlanDialog = false
          this.correctivePlanDesc = null
        })
    },

    async updateCorrectiveDueDate(item) {
      const xForm = {
        act: 'update',
        id: item.id,
        corrective_due_date: item.corrective_due_date
      }
      await axios
        .post(`${this.dssApi}audit/discoveryitem/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.$emit('getDiscoveryItems')
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async updateCorrectivePlanDueDate(item) {
      const xForm = {
        act: 'update',
        id: item.id,
        corrective_plan_due_date: item.corrective_plan_due_date
      }
      console.log('updateScore>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/discoveryitem/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.$emit('getDiscoveryItems')
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    }
  }
}
</script>
